import { SectionId } from '@wix/wix-help-widget-common/homepage';

import { sectionDataHooks } from './Section.dataHooks';

export const sectionIdToDataHook: Record<SectionId, string> = {
  [SectionId.Articles]: sectionDataHooks.articles(),
  [SectionId.HelpCenter]: sectionDataHooks.helpCenter(),
  [SectionId.Resources]: sectionDataHooks.resources(),
  [SectionId.HirePartner]: sectionDataHooks.hirePartner(),
  [SectionId.ContactUs]: sectionDataHooks.contactUs(),
  [SectionId.StatusPage]: sectionDataHooks.statusPage(),
  [SectionId.ChatWithUs]: sectionDataHooks.chatWithUs(),
  [SectionId.UserContacts]: sectionDataHooks.userContacts(),
  [SectionId.ShareFeedback]: sectionDataHooks.feedback(),
  [SectionId.RequestSuccessManager]: sectionDataHooks.requestSuccessManager(),
};
